export const formatCurrency = (value: number, qtdDecimais = 2): string => {
  const numberToFixedString = parseFloat(value.toString()).toFixed(qtdDecimais);

  return parseFloat(numberToFixedString).toLocaleString('pt-br', {
    minimumFractionDigits: qtdDecimais,
  });
};
